import React from 'react';
import PropTypes from 'prop-types';

import AppSettingsProvider from '@/components/AppSettingsProvider';

const withApp = (Component) => {
  const WithApp = React.memo(
    ({
      pageHeader,
      importantInformation,
      pointsPerDollar = 3,
      hotelsPointsPerDollar = 3,
      valuePropositions,
      webChatSpecialHours,
      qffPointTiers,
      maintenanceMessage,
      campaignMessage,
      warningMessage,
      ...props
    }) => (
      <AppSettingsProvider
        pageHeader={pageHeader}
        importantInformation={importantInformation}
        pointsPerDollar={pointsPerDollar}
        hotelsPointsPerDollar={hotelsPointsPerDollar}
        webChatSpecialHours={webChatSpecialHours}
        qffPointTiers={qffPointTiers}
        valuePropositions={valuePropositions}
        maintenanceMessage={maintenanceMessage}
        campaignMessage={campaignMessage}
        warningMessage={warningMessage}
      >
        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </AppSettingsProvider>
    ),
  );

  WithApp.propTypes = {
    pageHeader: PropTypes.any.isRequired,
    importantInformation: PropTypes.any.isRequired,
    pointsPerDollar: PropTypes.number,
    hotelsPointsPerDollar: PropTypes.number,
    webChatSpecialHours: PropTypes.any.isRequired,
    qffPointTiers: PropTypes.object.isRequired,
    valuePropositions: PropTypes.arrayOf(PropTypes.object),
    maintenanceMessage: PropTypes.object.isRequired,
  };

  return WithApp;
};

export default withApp;
